const API_URL = import.meta.env.VITE_API_BASE_URL;

function getToken() {
  return localStorage.getItem("token");
}

function getHeaders(extra = {}) {
  const token = getToken();

  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

async function parseBody(res) {
  const contentType = res.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    return res.json().catch(() => null);
  }

  return res.text().catch(() => null);
}

async function handleResponse(res, endpoint, method) {
  const payload = await parseBody(res);

  if (res.status === 401) {
    console.warn(`🔴 [API] Token inválido ou expirado ao acessar ${endpoint}`);
    localStorage.removeItem("token");
    localStorage.removeItem("usuarioLogado");
    localStorage.removeItem("empresaAtiva");
    localStorage.removeItem("empresas");

    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }

    throw new Error("Token inválido ou expirado");
  }

  if (!res.ok) {
    if (payload && typeof payload === "object") {
      throw new Error(
        payload.erro ||
          payload.error ||
          `Erro ${method} ${endpoint}: ${res.status}`,
      );
    }

    throw new Error(
      `Erro inesperado ${method} ${endpoint}: ${payload || res.status}`,
    );
  }

  return {
    data: payload,
    status: res.status,
    ok: res.ok,
    headers: res.headers,
  };
}

function buildQueryParams(params = {}) {
  const entries = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== "",
  );

  if (!entries.length) return "";

  const esc = encodeURIComponent;

  return "?" + entries.map(([k, v]) => `${esc(k)}=${esc(v)}`).join("&");
}

export const api = {
  get: (endpoint, options = {}) => {
    const { params, headers = {} } = options;
    const url = `${API_URL}${endpoint}${buildQueryParams(params)}`;

    return fetch(url, {
      method: "GET",
      headers: getHeaders(headers),
    }).then((res) => handleResponse(res, endpoint, "GET"));
  },

  post: (endpoint, data = {}, options = {}) => {
    const { headers = {} } = options;

    return fetch(`${API_URL}${endpoint}`, {
      method: "POST",
      headers: getHeaders(headers),
      body: JSON.stringify(data),
    }).then((res) => handleResponse(res, endpoint, "POST"));
  },

  put: (endpoint, data = {}, options = {}) => {
    const { headers = {} } = options;

    return fetch(`${API_URL}${endpoint}`, {
      method: "PUT",
      headers: getHeaders(headers),
      body: JSON.stringify(data),
    }).then((res) => handleResponse(res, endpoint, "PUT"));
  },

  patch: (endpoint, data = {}, options = {}) => {
    const { headers = {} } = options;

    return fetch(`${API_URL}${endpoint}`, {
      method: "PATCH",
      headers: getHeaders(headers),
      body: JSON.stringify(data),
    }).then((res) => handleResponse(res, endpoint, "PATCH"));
  },

  delete: (endpoint, options = {}) => {
    const { params, headers = {} } = options;
    const url = `${API_URL}${endpoint}${buildQueryParams(params)}`;

    return fetch(url, {
      method: "DELETE",
      headers: getHeaders(headers),
    }).then((res) => handleResponse(res, endpoint, "DELETE"));
  },
};
